import * as React from 'react'

const ComissionBig = (props) => (
  <svg
    width={96}
    height={84}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M38 64V32c0-4.4 3.56-8 8-8h36v-4c0-4.4-3.6-8-8-8H18c-4.44 0-8 3.6-8 8v56c0 4.4 3.56 8 8 8h56c4.4 0 8-3.6 8-8v-4H46c-4.44 0-8-3.6-8-8Zm12-32c-2.2 0-4 1.8-4 4v24c0 2.2 1.8 4 4 4h36V32H50Zm6 16c0 3.32 2.68 6 6 6s6-2.68 6-6-2.68-6-6-6-6 2.68-6 6Z"
      fill="#fff"
      opacity={0.32}
    />
  </svg>
)

export default React.memo(ComissionBig)
